import { render, staticRenderFns } from "./ItemGroupEditView.vue?vue&type=template&id=84f5f098"
import script from "./ItemGroupEditView.vue?vue&type=script&lang=js"
export * from "./ItemGroupEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports